// 商品冲调
import { GoodsReverseAction } from '@/redux/actions/reversal/constant';

export interface GoodsInfo {
  indexId: string;
  code: string; // sku编码
  name: string; // 商品名称
  specification: string; // 规格
  subject: string; // 科目
  price: string; // 售价（元）
  standardPrice: string; // 标价（元）
  initCount: string; // 初始数量
  currentCount: string; // 当前数量
  initTotalValue: string; // 初始小计金额(元)
  currentTotalValue: string; // 当前小计金额(元)
}

export interface MainState {
  goodsList: GoodsInfo[]; // 商品列表
}

export interface ReducerState extends MainState {
  isInit: boolean; // 初始化
  isLoading: boolean; // 加载中
}

const initialState: ReducerState = {
  isInit: false,
  isLoading: true,
  goodsList: [],
};

type ActionHandler<T> = (state: ReducerState, action: { payload: T }) => ReducerState;

const reducerMap = {
  [GoodsReverseAction.initDefaultState]: <ActionHandler<Partial<ReducerState>>>((
    state,
    { payload },
  ) => {
    return { ...state, ...payload };
  }),
  [GoodsReverseAction.setLoadingStatus]: <ActionHandler<boolean>>((state, { payload }) => {
    return { ...state, isLoading: payload };
  }),
  [GoodsReverseAction.setInitStatus]: <ActionHandler<boolean>>((state, { payload }) => {
    return { ...state, isInit: payload };
  }),

  [GoodsReverseAction.setGoodsList]: <ActionHandler<GoodsInfo[]>>((state, { payload }) => {
    return { ...state, goodsList: payload };
  }),
};

export const reducerMapper = (state = initialState, action) => {
  const actionType = action.type;
  const reducer = reducerMap[actionType];
  if (typeof reducer === 'function') {
    return reducer(<ReducerState>state, action);
  }
  return state;
};

export const storeName = 'goodsReversal';
